/**
 * Soma Psychos — store customizations (JS)
 *
 * Companion to assets/custom.css. Loaded on every page from
 * snippets/scripts.liquid; each part guards on the DOM it needs and does
 * nothing otherwise. Targets are found by structure, never by copy or
 * filenames, and nothing leaves a running loop behind.
 */
(() => {
  'use strict';

  /* ------------------------------------------------------------------------
     Hero video starter (any page with a Fabric hero video)
     sections/hero.liquid renders hero videos with preload="none", a poster
     and no autoplay, so nothing downloads on its own. Start only the video
     that is actually displayed for the current breakpoint; the hidden
     desktop/mobile counterpart never fetches a byte. Leave the poster in
     place for data-saver and reduced-motion visitors.
     ------------------------------------------------------------------------ */
  const heroVideos = [...document.querySelectorAll('video.hero__video')];
  if (heroVideos.length) {
    const saveData = navigator.connection?.saveData === true;
    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const startVisible = () => {
      if (saveData || reduceMotion) return;
      for (const v of heroVideos) {
        if (v.dataset.spStarted) continue;
        if (getComputedStyle(v).display === 'none') continue;
        v.dataset.spStarted = '1';
        v.preload = 'auto';
        v.muted = true;
        v.play().catch(() => { /* poster stays; autoplay was refused */ });
      }
    };
    startVisible();
    matchMedia('(min-width: 750px)').addEventListener('change', startVisible);
  }

  /* ------------------------------------------------------------------------
     Homepage-only effects
     ------------------------------------------------------------------------ */
  const main = document.querySelector('main[data-template="index"]');
  if (!main) return;

  /* E3 · Editorial headline — word-by-word reveal
     Wraps each word of the first <h2> in the editorial section in a span
     with its index, then flags the heading once it scrolls into view. The
     motion itself lives in custom.css (.sp-reveal / .is-in). */
  const heading = main.querySelector('.media-with-content .media-with-content__content h2');
  if (heading && !heading.classList.contains('sp-reveal')) {
    const words = heading.textContent.trim().split(/\s+/).filter(Boolean);
    if (words.length) {
      heading.replaceChildren(
        ...words.flatMap((word, i) => {
          const span = document.createElement('span');
          span.className = 'sp-word';
          span.style.setProperty('--sp-i', i);
          span.textContent = word;
          return i < words.length - 1 ? [span, ' '] : [span];
        })
      );
      heading.classList.add('sp-reveal');

      const reveal = () => heading.classList.add('is-in');
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            reveal();
            io.disconnect();
          }
        }, { threshold: 0.4 });
        io.observe(heading);
      } else {
        reveal();
      }
    }
  }
})();
